<template>
    <div data-name="filters" v-if="partnerCampaigns && partnerCampaigns.length && campaigns && campaigns.length">
        <div :class="{disabled: $route.query.id}" class="d-flex">
            <Select 
                v-if="campaigns && campaigns.length" 
                :list="campaigns" 
                type="campaigns" 
                :default-value="campaigns.find(item => item.id === filterParams.myCampaign)"
                filter="myCampaign"
                @setFilter="setFilter"
                placeholder="My Campaign"
                id="filter-my-campaign"
                :showSearch="true"
            />
            <Select 
                v-if="partnerCampaigns && partnerCampaigns.length && !unscheduledTab" 
                :list="partnerCampaigns" 
                filter="partnerCampaign" 
                :default-value="partnerCampaigns.find(item => item.id === filterParams.partnerCampaign)"
                type="campaigns" 
                @setFilter="setFilter"
                :showSearch="true"
                id="filter-partner-campaign"
                placeholder="Partner Campaign"
            />
            <DatePicker 
                @setFilter = "setFilter" 
                :start-date = "filters.startDate" 
                :end-date = "filters.endDate"
                id="filter-start-end-date"
                v-if="!unscheduledTab"
            />
            <Select
                v-if="!unscheduledTab && statuses" 
                filter="status" 
                :list = "statuses.map(item => item.charAt(0).toUpperCase() + item.slice(1))" 
                @setFilter="setFilter" 
                id="filter-status"
                :default-value="filterParams.status === 'accepted' ? 'confirmed' : filterParams.status"
                placeholder="Status"
                :showSearch="false"
            />
        </div>
        <Button 
            type="clear" 
            class="ml-auto" 
            @click.native = "resetAllFilters" 
            :active="activeButton" 
            :disabled = "!activeButton"
            id="filter-clear">
            <Icon class="mr-1" icon="clear-icon"/>
            clear
        </Button>
    </div>
</template>

<script>
import { useCampaigns, useFilters, useUserId, usePartnerCampaigns, useRouter } from '../../../../../core/hooks'
import Icon from '@/components/Theme/Icon'
import Button from '../../Button'
import DatePicker from './DatePicker'
import Select from './Select'
import {watch, ref, computed, reactive} from '@vue/composition-api'
import Loader from '../../../../../components/Icons/Loader'
import { dashboardUtils } from '../../../../../core/utils'
import router from '../../../../../router'
export default {
    name: 'Filters',
    components: {
        DatePicker,
        Select,
        Button,
        Icon,
        Loader
    },
    props: {
        data: Array
    },
    setup(props){
        const {filters, resetFilters, setFilter} = useFilters();
        const {userId} = useUserId();
        const {route} = useRouter();
        const {campaigns, loader} = useCampaigns(userId);
        const {partnerCampaigns} = usePartnerCampaigns(userId);

        const statuses = computed(() => {
            const routeName = route.value.name;
            return dashboardUtils.statuses[routeName]
        })

        const unscheduledTab = computed(() => {
            return route.value.query.type === 'unscheduled'
        })

        const resetAllFilters = () => {
            resetFilters();
            router.replace({
                query: {
                    ...route.value.query,
                    id: undefined
                }
            }).catch(() => {})
        }


        const filterParams = computed(() => {

            const data = props.data && props.data[0]

            if(route.value.query.id && data) {

                let myCampaign = null
                let partnerCampaign = null
                let status = null

                if(route.value.name === 'requests') {
                    [myCampaign, partnerCampaign] = route.value.query.type === 'sent' ? 
                                                    [data.sender.campaign, data.receiver.campaign] :
                                                    [data.receiver.campaign, data.sender.campaign]
                    status = data.status
                } else if(route.value.name === 'updates') {
                    myCampaign = data.cid
                    partnerCampaign = data.partnerUpdates && data.partnerUpdates.length === 1 ? 
                            data.partnerUpdates[0].campaign.campaign : 
                            null
                    status = data.spots && data.spots.filter(spot => spot && spot.posted).length ? 'posted' : 'pending'
                }

                return {
                    status,
                    myCampaign,
                    partnerCampaign,
                }
            } 
            return {
                status: filters.value.status,
                myCampaign: filters.value.myCampaign,
                partnerCampaign: filters.value.partnerCampaign
            }
        })


        const activeButton = computed(() => route.value.query.filters || route.value.query.id)

        return {
            filters,
            setFilter,
            resetFilters,
            resetAllFilters,
            unscheduledTab,
            activeButton,
            statuses,
            campaigns,
            partnerCampaigns,
            filterParams
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/variables.scss';
div[data-name="filters"] {
    height: 84px;
    border-top: 1px solid $c28;
    border-bottom: 1px solid $c28;
    padding-left: 24px;
    padding-right: 24px;
    display: flex;
    align-items: center;

    div[data-name="select"], div.date-range {
        margin-right: 16px;
    }

    .disabled {
        pointer-events: none;
        opacity: 0.5
    }
}

</style>